/**
 * HTMX extension: POST JSON bodies (selected + reason for reject, etc.).
 * Registered from htmxsetup so it works on pages that never load approval.js.
 */
export function registerSubmitJsonExtension(hx) {
  if (!hx || hx.__smaacSubmitJsonRegistered) return;
  hx.__smaacSubmitJsonRegistered = true;

  hx.defineExtension('submitjson', {
    onEvent: function (name, evt) {
      if (name === 'htmx:configRequest') {
        evt.detail.headers['Content-Type'] = 'application/json';
      }
    },
    encodeParameters(xhr, parameters, _elt) {
      xhr.overrideMimeType('text/json');
      const reasonInput = document.getElementById('reject_reason');

      let selected =
        parameters && parameters.selected !== undefined
          ? parameters.selected
          : Array.from(window.checked || []);

      if (typeof selected === 'string') {
        const s = selected.trim();
        if (!s) {
          selected = [];
        } else if (s.startsWith('[') && s.endsWith(']')) {
          try {
            selected = JSON.parse(s);
          } catch (_e) {
            selected = [s];
          }
        } else {
          selected = [s];
        }
      } else if (!Array.isArray(selected)) {
        selected = selected == null ? [] : [selected];
      }

      const body = {
        ...(parameters || {}),
        selected,
        reason: reasonInput ? reasonInput.value : '',
      };
      return JSON.stringify(body);
    },
  });
}
